<template>
  <div>
    <nav class="level">
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Calculated Rent Price</p>
          <b-tooltip
            label="This is the Average Price per Sqft times the Subject Property Sqft."
            position="is-top"
          >
            <p class="title has-text-weight-semibold">{{ $store.state.evaluation.rentCompGroup.calculatedValue | currency(0) }}</p>
          </b-tooltip>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Average Rent Price</p>
          <p class="subtitle">{{ $store.state.evaluation.rentCompGroup.averageRentPrice | currency(0) }}</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Average Rent per Sqft</p>
          <p class="subtitle">{{ $store.state.evaluation.rentCompGroup.averagePricePerSqft | currency(2) }}</p>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
